import { useState } from 'react';

const usePage = (initialPage: number, maxPage: number): [number, () => void, () => void, (p: number) => void] => {
  const [page, setPage] = useState(initialPage);
  const increment = () => setPage((p) => (p < maxPage ? p + 1 : maxPage));
  const decrement = () => setPage((p) => (p > 0 ? p - 1 : 0));
  const jump = (p: number) => setPage(p);
  return [page, increment, decrement, jump];
};

export default usePage;
